import { PhoneInput } from 'common/components/core/PhoneInput'
import { CountrySelectorButtonUi } from 'common/components/core/PhoneInput/components/CountrySelector/ui/CountrySelectorUi'
import { CountrySelectorWrapperUi } from 'common/components/core/PhoneInput/components/CountrySelector/ui/CountrySelectorWrapperUi'
import { PhoneInputInputUi } from 'common/components/core/PhoneInput/components/PhoneInput/ui/PhoneInputInputUi'
import { fieldStyles } from 'common/components/entities/Field/utils'
import { AlignType, BorderType, PaddingType } from 'common/types/styleTypes'
import { FontProps } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'
import { BoxShadowInterface } from 'tools/commands/migrate/utils/migrateUtils'

export interface PhoneNumberFieldUiNewProps
  extends FontProps,
    BoxShadowInterface {
  hasIcon?: boolean
  hasErrors?: boolean
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  backgroundColor?: string
  mobileBackgroundColor?: string
  placeholderColor?: string
  mobilePlaceholderColor?: string
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
}

const PhoneNumberFieldUiNew = styled(PhoneInput)<PhoneNumberFieldUiNewProps>`
  ${CountrySelectorWrapperUi} {
    ${fieldStyles}

    display: flex !important;
    width: unset !important;
    border-top-right-radius: unset !important;
    border-bottom-right-radius: unset !important;
    border-right: none !important; 
    padding: 0 !important;

    ${CountrySelectorButtonUi} {
      ${fieldStyles}

      border: none !important;
      border-top-right-radius: unset !important;
      border-bottom-right-radius: unset !important;
      padding: 0 !important;
      padding-left: 9px !important;
      height: unset !important;
    }
  }

  ${PhoneInputInputUi} {
    ${fieldStyles}

    border-top-left-radius: unset !important;
    border-bottom-left-radius: unset !important;
    height: unset !important;
  }
`
export default PhoneNumberFieldUiNew
